import { SuggestedBuildings } from '../../services/search';
import { Unit } from '../../services/units';

export interface SearchStateInterface {
  suggestions: SuggestedBuildings | null;
  results: Unit[];
  query: string | null;
  searchOffset: number;
  error: any;
}

export default class SearchState implements SearchStateInterface {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    public suggestions: SuggestedBuildings | null = null,
    public results: Unit[] = [],
    public error: any = undefined,
    public query: string | null = null,
    public searchOffset: number = 0
  ) {}
}
